export default __webpack_public_path__ + "static/media/login.79872296.svg";